import { Grid, Typography } from '@mui/material'

type Feature = {
  title: string
  body: string
}
const features: Array<Feature> = [
  {
    title: 'Fast and Accurate Billing',
    body: 'Creating bill of an account is super easy, fast and accurate. On every account there is a button to create bill, you just need to click it to create a bill and then you can share it on WhatsApp or you can print it.',
  },
  {
    title: 'Easy option to issue items',
    body: 'Issueing items and sharing Chaalan with party is super easy in this software. You just need to tap button on account and then fill the details such as date, items and save.',
  },
  {
    title: 'Easy option to receive items',
    body: 'It is very similar issue items, you just need to select which items you want to receive and save.',
  },
  {
    title: 'GST and non-GST invoicing',
    body: 'It is for all type stores, smaller and bigger. You can enable/disable GST while creating bills.',
  },
  {
    title: 'Create eway bills',
    body: 'You can easily create eway bill of any challan within our system, You do not need to visit govt site.',
  },
  {
    title: 'GST Filing reports',
    body: 'System will prepare reports for your GST filing, you can download GSTR1 & GSTR3B reports and upload it to the govt portal.',
  },
  {
    title: 'Apply differing rates for parties',
    body: 'Mostly our rates changes customer to customer, so we have provided easy option where you can set different rate for different customers.',
  },
  {
    title: 'Easily view balance items',
    body: 'Viewing balance items are super easy, you just need to click a button and it will show you list of pending items towards customer.',
  },
  {
    title: 'Monthly/Weekly Bills',
    body: 'You can easly create and save monthly/weekly bills, bills will be generated with unique invoice no',
  },
  {
    title: 'Ledger of an account',
    body: 'You can view ledegr of every account easly. You can share or print ledger of an account.',
  },
  {
    title: 'View transactions from a specific date',
    body: 'You can select a date and view all type of transactions of that date such as item issued, received, payment etc.',
  },
  {
    title: 'Quotations and agreements',
    body: 'Create and share quotations and agreements with your customers. Option to get rates from agreement automatically',
  },

  {
    title: 'Live due amounts for each account',
    body: 'Due amount of every account and sum of due amount of all accounts is always shown on first page. You do not need to click any button to check this',
  },
  {
    title: 'Printing and sharing',
    body: 'Almost every detail such as chaalans, invoices, quatations, agreements, daily transactions can be shared or printed easly',
  },
  {
    title: 'A super easy and powerful mobile app',
    body: 'You can use on laptop, mobile or tablets. Please do not under estimate mobile and as it has all the features what we have on laptop.',
  },
  {
    title: 'Easily accessible 24x7 customer support',
    body: 'We are always avaialble to support you, you can contact us on WhatsApp anytime: +917976757979',
  },
]
function FeaturesGrid() {
  return (
    <Grid container columnSpacing={6} rowSpacing={4} sx={{ flexWrap: 'wrap' }}>
      {features.map((feature, index) => {
        return (
          <Grid item xs={12} md={6} lg={4} key={index} sx={{ display: 'flex' }}>
            <Grid
              container
              direction="column"
              p={2}
              sx={{
                border: 1,
                borderColor: 'lightgray',
                backgroundColor: 'white',
              }}
            >
              <Grid item>
                <Typography variant="h2" sx={{ mb: 1.5 }}>
                  {feature.title}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">{feature.body}</Typography>
              </Grid>
            </Grid>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default FeaturesGrid
